var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgPodcast = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 12,
  height: 15,
  viewBox: "0 0 12 15",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M6 9.5a2.24 2.24 0 0 0 2.242-2.25l.008-4.5A2.247 2.247 0 0 0 6 .5a2.247 2.247 0 0 0-2.25 2.25v4.5A2.247 2.247 0 0 0 6 9.5zm3.975-2.25c0 2.25-1.905 3.825-3.975 3.825-2.07 0-3.975-1.575-3.975-3.825H.75c0 2.557 2.04 4.672 4.5 5.04v2.46h1.5v-2.46c2.46-.36 4.5-2.475 4.5-5.04H9.975z"
})));
export default SvgPodcast;